import {Component, Input, OnInit} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {ModuleExternalStaffComponent} from './module-external-staff/module-external-staff.component';
import {ExternalStaffService} from '../services/external-staff.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {LocalDataSource} from 'ng2-smart-table';
import {environment} from '../../environments/environment';
import {FilesService} from '../services/files.service';

@Component({
  selector: 'ngx-external-staff',
  templateUrl: './external-staff.component.html',
  styleUrls: ['./external-staff.component.scss'],
})
export class ExternalStaffComponent implements OnInit {
  @Input() stationId: string;
  externalStaff = {
    name: '',
    rfc: '',
    address: '',
    phone: '',
  };

  settings: any = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
      rfc: {
        title: 'RFC',
        filter: true,
      },
      phone: {
        title: 'Telefono',
        filter: true,
      },
      address: {
        title: 'Dirección',
        filter: true,
      },
    },
    noDataMessage: 'Sin registros',
  };

  loading = false;
  downloading = false;
  source: LocalDataSource;
  dataLoaded = false;

  constructor(
    private externalStaffService: ExternalStaffService,
    private dialogService: NbDialogService,
    private fileService: FilesService,
  ) {}

  async ngOnInit() {
    this.getExternalStaffStation();
  }

  async getExternalStaffStation() {
    this.loading = true;
    const [err, response]: any = await this.externalStaffService.getExternalStaffStation(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
    this.source = new LocalDataSource(response.data);
  }

  openModalNewExternalStaff(isEdit: boolean = false) {
    this.dialogService.open(ModuleExternalStaffComponent, {
      hasScroll: true,
      context: {
        externalStaff: this.externalStaff,
        stationId: this.stationId,
        isEdit,
      },
    }).onClose.subscribe((modified: boolean) => modified ? this.getExternalStaffStation() : console.error('no modificaron'));
  }

  async onCustom(event: any) {
    if (event.action === 'delete') {
      this.loading = true;
      const [err] = await this.externalStaffService.delete(this.stationId, event.data.id);
      this.loading = false;
      if (err) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
      this.getExternalStaffStation();
      this.alert('Proveedor Eliminado');
    } else if (event.action === 'edit') {
      this.externalStaff = event.data;
      this.openModalNewExternalStaff(true);
    }
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async downloadListProviders() {
    this.downloading = true;
    await this.fileService.downloadFile(`${environment.baseEndpoint}/filesGeneratorv2/providers/${this.stationId}`, 'lista_proveedores');
    this.downloading = false;
  }
}
